import { useMemo } from 'react';

import DepartmentsListAlert from './DepartmentsListAlert';
import DepartmentsListItem from './DepartmentsListItem';
import DepartmentsListRegionFilters from './DepartmentsListRegionFilters';
import type { DepartmentsByName } from './types';

export interface DepartmentsListProps {
  readonly selectedRegionFilter: number | null;
  readonly onRegionFilterChange: (officeId: number | null) => void;
  readonly departmentsByName: DepartmentsByName;
  readonly onClickDepartment: (departmentName: string | null) => void;
  readonly hasJobs: boolean;
}

const DepartmentsList = ({
  selectedRegionFilter,
  onRegionFilterChange,
  departmentsByName,
  onClickDepartment,
  hasJobs,
}: DepartmentsListProps) => {
  const sortedDepartments = useMemo(() => {
    const departments = Object.values(departmentsByName);
    return departments.sort((a, b) => a.name.localeCompare(b.name));
  }, [departmentsByName]);

  return (
    <>
      <DepartmentsListRegionFilters
        onFilterChange={onRegionFilterChange}
        selectedFilter={selectedRegionFilter}
      />
      <div className="divide-y divide-sandstone-500 border-t-2 border-b border-sandstone-500">
        {!hasJobs ? (
          <DepartmentsListAlert message="store_locator_no_results" />
        ) : (
          sortedDepartments.map((dept, i) => (
            <DepartmentsListItem
              {...dept}
              count={dept.jobs.length}
              key={dept.name}
              index={i}
              onClick={onClickDepartment}
            />
          ))
        )}
      </div>
    </>
  );
};

export default DepartmentsList;
